import state from './modulePropertyTypeState.js'
import mutations from './modulePropertyTypeMutations.js'
import actions from './modulePropertyTypeActions.js'
import getters from './modulePropertyTypeGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
